import { ComposedTableDataType } from 'components/ComposedTable/types';
import { generateFileForArchive } from 'components/GenerateFile/generateFileForArchive';
import { ARCHIVE_FILENAME } from './constants';
import { FileType, ArchiveDataType } from './types';

export const archiveData = <TData extends ComposedTableDataType>({
  gridRef,
  fileType,
  headerContent,
  footerContent,
  exportCols
}: ArchiveDataType<TData>): FormData => {
  const dataFile = new FormData();
  if (gridRef.current?.api) {
    const blobData =
      fileType === FileType.XLS || fileType === FileType.PDF
        ? gridRef.current.api.getDataAsExcel({
            columnKeys: exportCols as string[],
            prependContent: [
              { cells: [] },
              {
                cells: [
                  {
                    data: {
                      value: headerContent,
                      type: 'String'
                    }
                  }
                ]
              }
            ],
            appendContent: [
              { cells: [] },
              {
                cells: [
                  {
                    data: {
                      value: footerContent,
                      type: 'String'
                    }
                  }
                ]
              }
            ]
          })
        : undefined;

    const contentData =
      fileType === FileType.CSV
        ? gridRef.current.api.getDataAsCsv({
            columnKeys: exportCols as string[],
            prependContent: headerContent,
            appendContent: footerContent
          })
        : undefined;

    const fileExtension =
      fileType === FileType.CSV ? FileType.CSV : FileType.XLS;
    const pdfArchive = fileType === FileType.PDF;

    const { file } = generateFileForArchive({
      content: contentData,
      blob: blobData,
      fileName: ARCHIVE_FILENAME,
      fileExtension,
      pdfArchive
    });
    dataFile.append('dataFile', file);
  }
  return dataFile;
};
